import React, { useEffect, useState } from "react";
import { FaGraduationCap } from "react-icons/fa";
import { MdCheckCircle, MdTrendingUp } from "react-icons/md";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import Card from "../components/Card";
import Profile from "../components/Profile";
import ClassCalendar from "../components/Schedule";
import Chart from "../components/Chart";
import { useNavigate } from "react-router-dom";
import API from "../utils/axiosInstance";
import { useTranslation } from "react-i18next";   // ✅ Import i18n
import LanguageTranslation from "../components/languageTranslation"; // ✅ Import your language switcher
import "./Dashboard.css";
import i18n from "../../src/config/i18n"; // ✅ Import i18n for language direction
const Dashboard = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [courseStats, setCourseStats] = useState({
    purchased: 0,
    completed: 0,
    inProgress: 0,
  });
  const [upcomingClasses, setUpcomingClasses] = useState([]);
  const navigate = useNavigate();
  const { t } = useTranslation();  // ✅ Initialize translation

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      console.warn("Token not found. Redirecting to login.");
      navigate("/");
      return;
    }

    const fetchDashboardData = async () => {
      try {
        const { data: progressData } = await API.get("/progress");
        const purchased = progressData.length;
        const completed = progressData.filter(p => p.isCompleted === 1).length;
        const inProgress = purchased - completed;

        setCourseStats({ purchased, completed, inProgress });

        const user = JSON.parse(localStorage.getItem("user"));
        const userId = user?.id;
        const { data: allSchedules } = await API.get(`/schedules/user/${userId}`);

        const today = new Date();
        const upcoming = allSchedules
          .filter(entry => new Date(entry.schedule?.date) >= today)
          .sort((a, b) => new Date(a.schedule.date) - new Date(b.schedule.date))
          .slice(0, 3);

        setUpcomingClasses(upcoming);
      } catch (error) {
        console.error("❌ Error fetching dashboard data:", error.response?.data || error.message);
      }
    };

    fetchDashboardData();
  }, [navigate]);

  return (
    <div
      className="dashboard-wrapper"
      dir={['ar', 'fa', 'ir', 'he'].includes(i18n.language) ? 'rtl' : 'ltr'}
      style={{
        flexDirection: ['ar', 'fa', 'ir', 'he'].includes(i18n.language)
          ? 'row-reverse'
          : 'row',
      }}
    >

      <div className="sidebar-fixed">
        <Sidebar isOpen={isSidebarOpen} />
      </div>

      <div className="dashboard-main">
        <Navbar onToggleSidebar={() => setIsSidebarOpen(prev => !prev)} />
        {/* ✅ Add Language Selector for Testing */}


        <div className="dashboard-content">
          {/* ✅ Left Column */}
          <div className="left-column">
            <div className="cards-container">
              <Card title={t("CoursesPurchased")} value={courseStats.purchased} icon={<FaGraduationCap size={30} />} color="#EE1B24" />
              <Card title={t("CompletedCourses")} value={courseStats.completed} icon={<MdCheckCircle size={30} />} color="#4CBC5B" />
              <Card title={t("CoursesInProgress")} value={courseStats.inProgress} icon={<MdTrendingUp size={30} />} color="#FFC13D" />
            </div>

            {/* ✅ Promo Banner */}
            <div
              className={`promo-banner ${['ar', 'fa', 'ir', 'he'].includes(i18n.language) ? 'rtl' : ''}`}
            >
              <div className="promo-text">
                <h4>{t("GetDiscountVoucher")}</h4>
                <p>
                  {t("LearnWithExperts")}<br />
                  {t("LearnWithExperts2")}
                </p>
              </div>

              {/* Show the appropriate image based on language */}
              {['ar', 'fa', 'ir', 'he'].includes(i18n.language) ? (
                <img src="/instructorLeft.png" alt="Instructor RTL" className="promo-image rtl-image" />
              ) : (
                <img src="/instructor.svg" alt="Instructor" className="promo-image" />
              )}
            </div>


            {/* ✅ Progress Chart */}
            <div className="chart-container">
              <h5>{t("Progress")}</h5>
              <Chart />
            </div>
          </div>

          {/* ✅ Right Column */}
          <div className="right-column">
            <div className="profile-calendar">
              <Profile
                name="Pradeesh Manivannan"
                email="pr@godocm.com"
                image="/images/profile.svg"
                phone="+971 55 449 8416"
              />
              <div className="schedule-section">
                <h5>{t("Schedule")}</h5>
                <ClassCalendar />
              </div>
            </div>

            {/* ✅ Upcoming Classes */}
            <div className="upcoming-classes">
              <h5>{t("UpcomingClasses")}</h5>
              {upcomingClasses.length === 0 ? (
                <p>{t("NoUpcomingClasses")}</p>
              ) : (
                upcomingClasses.map((cls, index) => (
                  <div className="class-card" key={index}>
                    <div className="vertical-bar"></div>
                    <img src="/class-thumbnail.svg" alt="Class" className="class-image" />
                    <div>
                      <h6>{cls.schedule?.title || t("UntitledClass")}</h6>
                      <p>
                        {cls.schedule?.date ? new Date(cls.schedule.date).toDateString() : t("NoDate")}
                        {" "} {t("at")} {cls.schedule?.time || t("NoTime")}
                      </p>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
